import { Stack } from '@mui/material'
import Typography from '../../../../components/Typography'

interface TabHeaderProps {
  title: string
  caption: string
}

const TabHeader = ({ title, caption }: TabHeaderProps) => {
  return (
    <Stack direction='column'>
      <Typography fontWeight='bold' variant='body2' color='primary500'>
        {title}
      </Typography>
      <Typography variant='caption' color='grey900'>
        {caption}
      </Typography>
    </Stack>
  )
}

export default TabHeader
